/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePdfLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FilePdfLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.75 31v15H38v-.02c4.54-.236 6.75-2.69 6.75-7.48 0-4.877-2.291-7.332-7-7.492V31h-5Zm3 2.5v10H37v-.002l.25.002c2.083 0 3.049-.506 3.521-.979.473-.472.979-1.938.979-4.021s-.506-3.549-.979-4.021c-.472-.473-1.438-.979-3.521-.979-.085 0-.169 0-.25.002V33.5h-1.25ZM19 31v15h3v-5h4v-.015c1.212-.076 2.343-.44 3.194-1.291.966-.967 1.306-2.296 1.306-3.694 0-1.398-.34-2.727-1.306-3.694-.85-.85-1.982-1.215-3.194-1.29V31h-7Zm3 2.5v5h3.502c.942 0 1.363-.423 1.562-.621l.009-.009c.194-.195.677-.913.677-1.87 0-.957-.483-1.674-.677-1.868l-.01-.01c-.199-.2-.621-.622-1.563-.622H22ZM47 46V31h10v2.5h-7v4h6.5V40H50v6h-3Z",
        fill: "#F25123"
      }
    )
  );
};
export {
  FilePdfLarge
};
